import React, { FC, useEffect, useState } from 'react';

import styled from 'styled-components';

import aampeTheme from '../../../constants/aampeTheme';

import { getRelativeDateString } from '../../../helpers/dateTimeHelpers';

interface AampeSavingInfoIndicatorProps {
    updatedAt?: string;
    isUpdating?: boolean;
    onlyValue?: boolean;
}

const AampeSavingInfoIndicator: FC<
    React.PropsWithChildren<AampeSavingInfoIndicatorProps>
> = ({ updatedAt, isUpdating, onlyValue }) => {
    const [relativeDate, setRelativeDate] = useState<string | null>(null);

    useEffect(() => {
        let intervalId: any = undefined;
        if (updatedAt) {
            setRelativeDate(getRelativeDateString(updatedAt));
            intervalId = setInterval(
                () => setRelativeDate(getRelativeDateString(updatedAt)),
                60000,
            );
        }

        return () => {
            if (intervalId) {
                clearInterval(intervalId);
            }
        };
    }, [updatedAt]);

    if (!updatedAt) return null;
    if (isUpdating) return <Text>Saving...</Text>;
    if (onlyValue) {
        return <Text>{`(${relativeDate})`}</Text>;
    }
    return <Text>Last saved {relativeDate}</Text>;
};

const Text = styled.span(() => ({
    color: aampeTheme.colors.neutral09,
    fontSize: 12,
    marginRight: aampeTheme.spacing(2),
}));

export default AampeSavingInfoIndicator;
